export const s3Config = {
    bucketName: 'payville',
    dirName: 'users',
    region: 'ap-south-1',
    accessKeyId: 'AKIAQK2RWOCI56MNCDXW',
    secretAccessKey: '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',
}

